import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@antimatterhq/ui/lib/utils';

export const inputVariants = cva(
  'flex h-10 w-full rounded-md border px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
  {
    variants: {
      variant: {
        default:
          'bg-white dark:bg-transparent border-grey-200 dark:border-grey-650 text-grey-800 dark:text-grey-100 placeholder:text-grey-400 dark:placeholder:text-grey-500 focus-visible:ring-blue-600 dark:focus-visible:ring-blue-500 hover:border-blue-700 dark:hover:border-blue-400',
        success:
          'bg-green-100/10 dark:bg-transparent border-green-600 dark:border-green-500 text-green-600 dark:text-green-500 focus-visible:ring-green-100 dark:focus-visible:ring-green-600/16',
        warning:
          'bg-yellow-100/10 dark:bg-transparent border-yellow-600 dark:border-yellow-500 text-yellow-600 dark:text-yellow-500 focus-visible:ring-yellow-100 dark:focus-visible:ring-yellow-600/16',
        error:
          'bg-red-100/10 dark:bg-transparent border-red-600 dark:border-red-500 text-red-600 dark:text-red-500 focus-visible:ring-red-100 dark:focus-visible:ring-red-600/16',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

export type InputProps = {} & React.InputHTMLAttributes<HTMLInputElement> &
  VariantProps<typeof inputVariants>;

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, variant, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          inputVariants({
            variant,
            className,
          }),
        )}
        ref={ref}
        {...props}
      />
    );
  },
);

Input.displayName = 'Input';
